import { render, staticRenderFns } from "./ReturnedProductSets.vue?vue&type=template&id=24867bbc&scoped=true"
import script from "./ReturnedProductSets.vue?vue&type=script&lang=ts"
export * from "./ReturnedProductSets.vue?vue&type=script&lang=ts"
import style0 from "./ReturnedProductSets.vue?vue&type=style&index=0&id=24867bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24867bbc",
  null
  
)

export default component.exports